import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const MANAGE_RATE_CARDS = 'manage rate cards'
export const MANAGE_GROUPS = 'manage groups'
export const MANAGE_USERS = 'manage users'
export const MANAGE_SURVEYS = 'manage surveys'
export const HISTORY = 'history'
export const CHANGE_PASSWORD = 'change password'

export default {
  [PORTUGUESE]: {
    [MANAGE_RATE_CARDS]: 'Gerenciar Tabelas de Preços',
    [MANAGE_GROUPS]: 'Gerenciar Grupos',
    [MANAGE_USERS]: 'Gerenciar Usuários',
    [MANAGE_SURVEYS]: 'Gerenciar Pesquisas',
    [HISTORY]: 'Histórico',
    [CHANGE_PASSWORD]: 'Mudar Senha',
  },

  [ENGLISH]: {
    [MANAGE_RATE_CARDS]: 'Manage Rate Cards',
    [MANAGE_GROUPS]: 'Manage Groups',
    [MANAGE_USERS]: 'Manage Users',
    [MANAGE_SURVEYS]: 'Manage Surveys',
    [HISTORY]: 'History',
    [CHANGE_PASSWORD]: 'Change Password',
  },

  [SPANISH]: {
    [MANAGE_RATE_CARDS]: 'Administrar Tarjeta de Tarifas',
    [MANAGE_GROUPS]: 'Administrar Grupos',
    [MANAGE_USERS]: 'Administrar Usuarios',
    [MANAGE_SURVEYS]: 'Administrar Encuestas',
    [HISTORY]: 'Histórico',
    [CHANGE_PASSWORD]: 'Cambia la Contraseña',
  },
}
